import React from 'react';

type ZipZapIconProps = {
  className?: string;
  height?: number;
  width?: number;
}

export const ZipZapIcon: React.FC<ZipZapIconProps> = ({ 
  className,
  height = 20, 
  width = 20 
}) => (
  <svg 
    className={className}
    fill="none" 
    height={height} 
    viewBox="0 0 20 20" 
    width={width} 
    xmlns="http://www.w3.org/2000/svg"
  > 
    <path 
      d="M7.49935 14.5833H2.91602M5.41602 10H1.66602M7.49935 5.41667H3.33268M14.166 2.5L8.66899 10.1958C8.42568 10.5365 8.30403 10.7068 8.3093 10.8488C8.31388 10.9724 8.37316 11.0876 8.4711 11.1632C8.58358 11.25 8.79288 11.25 9.21147 11.25H13.3327L12.4993 17.5L17.9964 9.80416C18.2397 9.46353 18.3613 9.29322 18.3561 9.15123C18.3515 9.0276 18.2922 8.9124 18.1943 8.83682C18.0818 8.75 17.8725 8.75 17.4539 8.75H13.3327L14.166 2.5Z" 
      stroke="black" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      strokeWidth="1.67" 
    /> 
  </svg> 
);